import {Component, Input, OnInit} from '@angular/core';
import {fromEvent} from 'rxjs';
import {takeWhile} from 'rxjs/operators';
import {ModalController} from '@ionic/angular';
import {Restaurant} from '../../../core/models/restaurant.model';
import {parsePhoneNumberFromString} from 'libphonenumber-js';
import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/core/services/util.service';

@Component({
  selector: 'app-location-list',
  templateUrl: './location-list.component.html',
  styleUrls: ['./location-list.component.scss']
})
export class LocationListComponent implements OnInit {
  @Input() locationList: Restaurant[];
  @Input() chosenLocationIndex: number;

  public touchSwipeElement = true;

  constructor(private modalController: ModalController,
    private utilService: UtilService) { }

  ngOnInit() {
    const checkExist = setInterval(() => {
      if (document.getElementById('swipeZone')) {
        const hammerTime = new Hammer(document.getElementById('swipeZone'));
        hammerTime.get('swipe').set({
          direction: Hammer.DIRECTION_DOWN
        });
        fromEvent(hammerTime, 'swipe').pipe(
          takeWhile(() => this.touchSwipeElement))
          .subscribe(() => {
            this.closeModal();
          });
        clearInterval(checkExist);
      }
    }, 500);
  }

  public formatToStyleImageUrl(location: Restaurant): string {
    if (!location.isMobileEnabled) {
      return `linear-gradient( rgba(0,0,0,.8), rgba(0,0,0,.8) ), url(${this.utilService.isStoneCreek() ? location.locationImageUrl : location.locationBanner})`;
    }
    return `linear-gradient( rgba(0,0,0,.6), rgba(0,0,0,.6) ), url(${this.utilService.isStoneCreek() ? location.locationImageUrl : location.locationBanner})`;
  }

  public formatPhoneNumber(phone: string, formatType: string, country: any = 'US'): string {
    if (phone) {
      const phoneNumber = parsePhoneNumberFromString(phone.toString(), country);
      if (formatType === 'national') {
        return phoneNumber.formatNational();
      } else if (formatType === 'international') {
        return phoneNumber.formatInternational();
      }
    }
    return '';
  }

  public isChosenLocation(locationIndex: number) {
    return this.chosenLocationIndex === locationIndex;
  }

  public chooseLocation(locationIndex: number) {
    if (!this.locationList[locationIndex].isMobileEnabled) {
      return;
    }
    this.modalController.dismiss({ locationIndex });
  }

  public closeModal() {
    this.modalController.dismiss();
  }
}
